import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: () => import('../views/Layout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('../views/Home.vue'), meta: { title: '首页' } },
      { path: 'about', name: 'AboutUs', component: () => import('../views/AboutUs.vue'), meta: { title: '关于我们' } },
      { path: 'pricing', name: 'Pricing', component: () => import('../views/Pricing.vue'), meta: { title: '套餐价格' } },
      { path: 'cases', name: 'Cases', component: () => import('../views/Cases.vue'), meta: { title: '案例中心' } },
      { path: 'card-templates', name: 'CardTemplates', component: () => import('../views/CardTemplates.vue'), meta: { title: '制卡模板' } },
      { path: 'articles', name: 'Articles', component: () => import('../views/Articles.vue'), meta: { title: '帮助中心' } },
      { path: 'articles/:cid', name: 'ArticleDetail', component: () => import('../views/ArticleDetail.vue'), meta: { title: '文章详情' } },
      { path: 'article/:slug', name: 'ArticleBySlug', component: () => import('../views/ArticleDetail.vue'), meta: { title: '文章详情' } },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
